
import {useEffect, useState} from "react";
import axios from "axios";
import {API_BASE} from "../utils/api";
import {TChemical, TDataOilfield} from "./usePDOilfield";
import {OILFIELD_PERCENT, OILFIELD_PRODUCTION_CONST, OILFIELD_WELLS_DEFAULT} from "../utils/consts";
import {getMedianOfTopPercent, getWellsData} from "../utils/utils";
import {TData} from "./usePDGeothermal";


export interface WellsBar {
		name: string,
		cost: number,
		price: number,

}
export const useWellsOilfield = () => {
		const [data, setData] = useState<{data: TData, chemical: TChemical}>({data: [], chemical: []});
		const [calculatedData, setCalculatedData] = useState<WellsBar[]>();
		const [loading, setLoading] = useState(true);
		useEffect(() => {
				const fetchData = async () => {
						try {
								setLoading(true);
								const response = await axios.get(`${API_BASE}/concentration/oilfield`, {
									headers: {
										'content-type': 'application/json',
									}
								});
								setData({data: response.data.data, chemical: response.data.chemical});
						} catch (error) {
								console.error(error);
						} finally {
								setLoading(false);
						}
				};
				fetchData();

		}, []);

		useEffect(() => {
				const calculatedData = getMedianOfTopPercent(data!.data, data!.chemical, OILFIELD_PERCENT, OILFIELD_PRODUCTION_CONST, OILFIELD_WELLS_DEFAULT);
				const finalData = getWellsData(calculatedData);
				setCalculatedData(finalData);
		}, [data])

		return { data, calculatedData, loading, setData };
}